import { USER_ERROR, SET_USER, SET_DOCUMENTS } from "../actions/userActions";

const initialState = {
  data: {},
  documents: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_ERROR:
      return { ...state, error: action.error };
    case SET_USER:
      return { ...state, data: action.user };
    case SET_DOCUMENTS:
      return { ...state, documents: action.payload };
    default:
      return { ...state };
  }
}
